import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailInfoboxComponent } from '../../components/email-infobox/email-infobox.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import {
  EmailReferralsLogoComponent,
  Language,
} from '../../components/email-referrals-logo/email-referrals-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunMarkAsHtmlPipe } from '../../pipes/mailgun-mark-as-html.pipe';

@Component({
  standalone: true,
  selector: 'email-referral-send-invitation-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './referral-send-invitation.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailReferralsLogoComponent,
    EmailMailgunIfDirective,
    EmailInfoboxComponent,
    MailgunMarkAsHtmlPipe,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class ReferralSendInvitationTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<ReferralSendInvitationTemplateData>;
}

export type ReferralSendInvitationTemplateData = {
  title: string;
  p1: string;
  avatar_url: string;
  message_html: string;
  p2: string;
  button_link: string;
  button_text: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
  language: Language;
};

export const ReferralSendInvitationTemplateMocks: ReferralSendInvitationTemplateData[] = [
  {
    title: "Join ACME's referral portal",
    p1: "Olivia Novak invited you to ACME's referral portal.",
    avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
    message_html:
      '<p>This is a place for personalized invitation written by admin with access to inviting new referrers. A great answer to custom onboarding needs.</p>',
    p2: "The referral portal is a hub for discovering your company's open jobs, referring from your network, and collecting rewards for hired connections.",
    button_link: 'http://recruitee.com',
    button_text: 'Join your team now',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
    language: {
      en: true,
      de: false,
      fr: false,
      nl: false,
      sv: false,
      fi: false,
    },
  },
];
